import React from 'react';

import { OrganizationAppShell, OrganizationSettings, Settings } from '~/components/layouts';
import { WebBookingSettings } from '~/components/pages/Settings_Organization_WebBookingSettings';
import { FirebaseProvider } from '~/components/partials';

const SettingsOrganizationWebBookingSettingsPage = () => {
  return (
    <FirebaseProvider>
      <OrganizationAppShell>
        <Settings>
          <OrganizationSettings>
            <WebBookingSettings />
          </OrganizationSettings>
        </Settings>
      </OrganizationAppShell>
    </FirebaseProvider>
  );
};

export default SettingsOrganizationWebBookingSettingsPage;
